import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { createI18n } from 'vue-i18n'
import { languages } from '@/i18n-translate'
import { defaultLocale } from '@/i18n-translate'
import { createHead } from '@unhead/vue'

const head = createHead()
const messages = Object.assign(languages)
const i18n = createI18n({
    legacy: false,
    locale: defaultLocale,
    fallbackLocale: 'en',
    messages
})
const app = createApp(App)
    .use(i18n)
    .use(store)
    .use(router)
    .use(head)
app.config.globalProperties.$axios = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || ''
});

app.mount('#app');
